import React from "react";

function Pagenotfound(){
    return(
        <div style={{
            height: "100vh",
            backgroundSize: "cover",
            backgroundImage: `url("https://static.vecteezy.com/system/resources/previews/001/857/111/original/error-404-page-not-found-landing-page-concept-for-mobile-and-pc-free-vector.jpg")`,
            backgroundPosition: "center center"
        }}>
            
        </div>
    )
}

export default Pagenotfound;